// Changelog data - in real app, this could come from an API
export const changes = [

  // ----------------------------------------------------------------------------
  // Version 1.5.0
  // ----------------------------------------------------------------------------
  {
    version: "1.5.0",
    date: "2025-05-07",
    description: "Introduced context-aware AI command palette and company ownership update",
    changes: [
        {
            changeTitle: "New Features",
            changeType: "feature",
            changeBullets: [
                {
                    bulletContent: "AI Command Palette",
                    subBullets: [
                        "Added smart AI-powered command suggestions",
                        "Improved command discovery and execution"
                    ]
                },
                {
                    bulletContent: "Context Awareness",
                    subBullets: [
                        "Enhanced awareness of workspace environment",
                        "Smarter suggestions based on current tasks"
                    ]
                }
            ]
        },
        {
            changeTitle: "User Experience",
            changeType: "improvement",
            changeBullets: [
                {
                    bulletContent: "Interface Improvements",
                    subBullets: [
                        "Redesigned command palette for better usability",
                        "Enhanced task modal with improved UX and layout"
                    ]
                },
                {
                    bulletContent: "General bug fixes and improvements",
                    subBullets: [
                        "Various notification system improvements",
                        "Multiple performance enhancements",
                        "Fixed several UI inconsistencies"
                    ]
                }
            ]
        },
        {
            changeTitle: "Company Update",
            changeType: "announcement",
            changeBullets: [
                {
                    bulletContent: "Ownership Change",
                    subBullets: [
                        "StatusBot, Inc. is now the official owner of StatusBot",
                        "New corporate structure to support continued growth"
                    ]
                }
            ]
        }
    ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.4.0
  // ----------------------------------------------------------------------------
  {
    version: "1.4.0",
    date: "2025-04-06",
    description: "New & improved monitor server architecture in preparation for browser agent monitoring",
    changes: [
        {
            changeTitle: "New Features",
            changeType: "feature",
            changeBullets: [
                {
                    bulletContent: "Faster monitor runs",
                    subBullets: [
                        "Improved monitor run architecture"
                    ]
                },
                {
                    bulletContent: "Enhanced member invite management",
                    subBullets: [
                        "View pending and expired invites",
                        "Resend & delete invites"
                    ]
                }
            ]
        },
        {
            changeTitle: "Platform Improvements",
            changeType: "improvement",
            changeBullets: [
                {
                    bulletContent: "User Interface",
                    subBullets: [
                        "Enhanced mobile responsiveness for project headers",
                    ]
                }
            ]
        }
    ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.3.2
  // ----------------------------------------------------------------------------
  {
    version: "1.3.2",
    date: "2025-03-15",
    description: "Enhanced monitoring system stability, improved user experience, and various UI improvements",
    changes: [
        {
            changeTitle: "New Features",
            changeType: "feature",
            changeBullets: [
                {
                    bulletContent: "Enhanced Task Management",
                    subBullets: [
                        "Made backlog visible by default in list view",
                        "Implemented dynamic status management",
                        "Added horizontal scrolling for board columns"
                    ]
                },
                {
                    bulletContent: "Improved Onboarding",
                    subBullets: [
                        "Added team information collection during signup"
                    ]
                },
                {
                    bulletContent: "Monitor Enhancements",
                    subBullets: [
                        "Implemented automatic monitor name generation",
                        "Enhanced monitor security endpoints",
                        "Improved SSL certificate handling for path monitoring",
                        "Enhanced monitor initialization process"
                    ]
                }
            ]
        },
        {
            changeTitle: "Platform Improvements",
            changeType: "improvement",
            changeBullets: [
                {
                    bulletContent: "System Optimization",
                    subBullets: [
                        "Enhanced cron job management system",
                        "Optimized monitor runs architecture",
                        "Improved system reliability and performance"
                    ]
                },
                {
                    bulletContent: "User Interface",
                    subBullets: [
                        "Enhanced mobile responsiveness for task details",
                        "Improved overall user experience"
                    ]
                }
            ]
        }
    ]
  },
  
  // ----------------------------------------------------------------------------
    // Version 1.3.1
    // ----------------------------------------------------------------------------
    {
        version: "1.3.1",
        date: "2025-02-25",
        description: "Introduced filtering and sorting features, enhanced step indicators, improved link support, and refined attachment handling",
        changes: [
            {
                changeTitle: "New Features",
                changeType: "feature",
                changeBullets: [
                    {
                        bulletContent: "Filtering & Sorting Enhancements",
                        subBullets: [
                            "Implemented advanced filtering and sorting for better task organization",
                            "Enhanced column management for improved workflow"
                        ]
                    },
                    {
                        bulletContent: "Link Management",
                        subBullets: [
                            "Enhanced link formatting capabilities",
                            "Improved link management interface",
                            "Streamlined link-related actions for better usability"
                        ]
                    },
                    {
                        bulletContent: "File Management",
                        subBullets: [
                            "Enhanced file upload and management system",
                            "Improved attachment handling for various file types",
                            "Streamlined file download experience"
                        ]
                    }
                ]
            },
            {
                changeTitle: "Enhancements",
                changeType: "improvement",
                changeBullets: [
                    {
                        bulletContent: "Monitor Management",
                        subBullets: [
                            "Enhanced progress tracking visualization",
                            "Improved security measures for monitor updates",
                            "Enhanced access control system"
                        ]
                    },
                    {
                        bulletContent: "User Interface Updates",
                        subBullets: [
                            "Improved form styling and consistency",
                            "Enhanced input field interactions",
                            "Streamlined user experience across the platform"
                        ]
                    }
                ]
            }
        ]
    },

    // ----------------------------------------------------------------------------
    // Version 1.3.0
    // ----------------------------------------------------------------------------
    {
      version: "1.3.0",
      date: "2025-02-21",
      description: "Introduced intelligent monitoring with predictive analytics and automated incident response",
      changes: [
        {
          changeTitle: "New Features",
          changeType: "feature",
          changeBullets: [
            {
              bulletContent: "Access Management",
              subBullets: [
                "Implemented streamlined waitlist system",
                "Enhanced user onboarding process",
                "Added automated notification system for access updates"
              ]
            },
            {
              bulletContent: "Media Support",
              subBullets: [
                "Enhanced comment system with image support",
                "Improved media handling capabilities"
              ]
            }
          ]
        },
        {
          changeTitle: "Platform Improvements",
          changeType: "improvement",
          changeBullets: [
            {
              bulletContent: "System Enhancements",
              subBullets: [
                "Improved authentication system",
                "Enhanced form validation and error handling",
                "Optimized mobile experience",
                "Improved overall system performance"
              ]
            }
          ]
        }
      ]
    },
  
    // ----------------------------------------------------------------------------
    // Version 1.2.9
    // ----------------------------------------------------------------------------
    {
      version: "1.2.9",
      date: "2025-02-12",
      description: "Enhanced AI capabilities for improved task context understanding",
      changes: [
        {
          changeTitle: "AI Enhancements",
          changeType: "improvement",
          changeBullets: [
            {
              bulletContent: "Intelligent Task Management",
              subBullets: [
                "Enhanced AI system for better task context understanding",
                "Improved task organization through AI assistance"
              ]
            }
          ]
        }
      ]
    },
  
    // ----------------------------------------------------------------------------
    // Version 1.2.8
    // ----------------------------------------------------------------------------
    {
      version: "1.2.8",
      date: "2025-02-07",
      description: "Enhanced authentication experience and improved task organization",
      changes: [
        {
          changeTitle: "User Experience",
          changeType: "improvement",
          changeBullets: [
            {
              bulletContent: "Authentication Improvements",
              subBullets: [
                "Introduced streamlined login experience with Magic Link",
                "Enhanced user authentication flow"
              ]
            },
            {
              bulletContent: "Task Organization",
              subBullets: [
                "Enhanced task categorization with visual improvements",
                "Improved task label management system"
              ]
            }
          ]
        },
        {
          changeTitle: "Collaboration Features",
          changeType: "improvement",
          changeBullets: [
            {
              bulletContent: "Enhanced Communication",
              subBullets: [
                "Improved comment system with enhanced mentions",
                "Optimized task description handling",
                "Enhanced notification system for better collaboration"
              ]
            }
          ]
        }
      ]
    },
  
    // ----------------------------------------------------------------------------
    // Version 1.2.7
    // ----------------------------------------------------------------------------
    {
      version: "1.2.7",
      date: "2025-02-01",
      description: "Enhanced security measures and authentication system",
      changes: [
        {
          changeTitle: "Security",
          changeType: "improvement",
          changeBullets: [
            {
              bulletContent: "Authentication Enhancements",
              subBullets: [
                "Implemented advanced security measures for improved user authentication",
                "Enhanced session management capabilities"
              ]
            }
          ]
        }
      ]
    },
  
    // Version 1.2.6
    // ----------------------------------------------------------------------------
    {
      version: "1.2.6",
      date: "2025-01-20",
      description: "Performance optimizations and improved user experience",
      changes: [
        {
          changeTitle: "Platform Improvements",
          changeType: "improvement",
          changeBullets: [
            {
              bulletContent: "Performance Enhancements",
              subBullets: [
                "Improved loading states for better user experience",
                "Enhanced system responsiveness",
                "Optimized task component loading",
                "Improved project list performance"
              ]
            },
            {
              bulletContent: "Navigation Improvements",
              subBullets: [
                "Enhanced navigation system",
                "Improved UI consistency across the platform"
              ]
            }
          ]
        },
        {
          changeTitle: "User Management",
          changeType: "improvement",
          changeBullets: [
            {
              bulletContent: "Email Handling",
              subBullets: [
                "Improved email management system",
                "Enhanced email handling consistency"
              ]
            }
          ]
        }
      ]
    },
  
    // ----------------------------------------------------------------------------
    // Version 1.2.5
    // ----------------------------------------------------------------------------
    {
      version: "1.2.5",
      date: "2025-01-15",
      description: "Brand refresh and enhanced notification system",
      changes: [
        {
          changeTitle: "Platform Updates",
          changeType: "improvement",
          changeBullets: [
            {
              bulletContent: "Brand Evolution",
              subBullets: [
                "Introduced new branding across the platform",
                "Enhanced visual consistency throughout the application"
              ]
            },
            {
              bulletContent: "Platform Optimization",
              subBullets: [
                "Improved search engine optimization",
                "Enhanced platform visibility"
              ]
            },
            {
              bulletContent: "Communication System",
              subBullets: [
                "Enhanced notification system with improved user controls",
                "Added comprehensive email notification preferences",
                "Improved notification delivery and clarity"
              ]
            }
          ]
        }
      ]
    },
  
    // ----------------------------------------------------------------------------
    // Version 1.2.4
    // ----------------------------------------------------------------------------
    {
      version: "1.2.4",
      date: "2025-01-09",
      description: "Enhanced media handling and improved task management experience",
      changes: [
          {
              changeTitle: "Platform Improvements",
              changeType: "improvement",
              changeBullets: [
                  {
                      bulletContent: "Media Management",
                      subBullets: [
                          "Enhanced image upload capabilities",
                          "Improved attachment handling system",
                          "Streamlined media integration in tasks"
                      ]
                  },
                  {
                      bulletContent: "Task Management",
                      subBullets: [
                          "Enhanced task description system",
                          "Improved editing experience"
                      ]
                  }
              ]
          }
      ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.2.3
  // ----------------------------------------------------------------------------
  {
      version: "1.2.3",
      date: "2025-01-02",
      description: "Enhanced collaboration features and improved activity tracking",
      changes: [
          {
              changeTitle: "Collaboration Features",
              changeType: "improvement",
              changeBullets: [
                  {
                      bulletContent: "Enhanced Text Editor",
                      subBullets: [
                          "Added advanced formatting options",
                          "Improved content management capabilities",
                          "Enhanced text storage format for better reliability"
                      ]
                  },
                  {
                      bulletContent: "Team Collaboration",
                      subBullets: [
                          "Introduced user mentions in comments and descriptions",
                          "Enhanced notification system for mentions",
                          "Improved activity timeline visualization"
                      ]
                  }
              ]
          }
      ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.2.2
  // ----------------------------------------------------------------------------
  {
      version: "1.2.2",
      date: "2024-12-23",
      description: "Introduced task scheduling and enhanced activity tracking",
      changes: [
          {
              changeTitle: "Task Management",
              changeType: "improvement",
              changeBullets: [
                  {
                      bulletContent: "Task Scheduling",
                      subBullets: [
                          "Added due date functionality",
                          "Enhanced task organization features",
                          "Improved date handling across time zones"
                      ]
                  },
                  {
                      bulletContent: "Activity Tracking",
                      subBullets: [
                          "Enhanced activity timeline with improved organization",
                          "Streamlined activity tracking for better visibility"
                      ]
                  }
              ]
          }
      ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.2.1
  // ----------------------------------------------------------------------------
  {
      version: "1.2.1",
      date: "2024-12-18",
      description: "Introduced project settings and enhanced task organization",
      changes: [
          {
              changeTitle: "Project Management",
              changeType: "improvement",
              changeBullets: [
                  {
                      bulletContent: "Project Settings",
                      subBullets: [
                          "Introduced comprehensive project configuration options",
                          "Enhanced project management capabilities"
                      ]
                  },
                  {
                      bulletContent: "Task Organization",
                      subBullets: [
                          "Enhanced task labeling system",
                          "Improved task categorization features"
                      ]
                  }
              ]
          }
      ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.2.0
  // ----------------------------------------------------------------------------
  {
      version: "1.2.0",
      date: "2024-12-06",
      description: "Enhanced task organization with improved categorization",
      changes: [
          {
              changeTitle: "Task Management",
              changeType: "improvement",
              changeBullets: [
                  {
                      bulletContent: "Task Categories",
                      subBullets: [
                          "Introduced comprehensive task labeling system",
                          "Enhanced task organization capabilities",
                          "Improved activity tracking for task updates"
                      ]
                  }
              ]
          }
      ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.1.9
  // ----------------------------------------------------------------------------
  {
      version: "1.1.9",
      date: "2024-11-28",
      description: "Enhanced security and AI-powered search capabilities",
      changes: [
          {
              changeTitle: "Platform Security",
              changeType: "feature",
              changeBullets: [
                  {
                      bulletContent: "Security Enhancements",
                      subBullets: [
                          "Implemented advanced access control system",
                          "Enhanced organization security measures"
                      ]
                  },
                  {
                      bulletContent: "AI Integration",
                      subBullets: [
                          "Enhanced AI-powered search capabilities",
                          "Improved intelligent insights generation"
                      ]
                  }
              ]
          }
      ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.1.8
  // ----------------------------------------------------------------------------
  {
      version: "1.1.8",
      date: "2024-11-21",
      description: "Improved time zone handling and task management",
      changes: [
          {
              changeTitle: "Global Usage",
              changeType: "improvement",
              changeBullets: [
                  {
                      bulletContent: "Time Zone Management",
                      subBullets: [
                          "Enhanced time zone support for global teams",
                          "Improved date and time handling across regions"
                      ]
                  }
              ]
          }
      ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.1.7
  // ----------------------------------------------------------------------------
  {
      version: "1.1.7",
      date: "2024-11-19",
      description: "Enhanced task creation and management capabilities",
      changes: [
          {
              changeTitle: "Task Management",
              changeType: "improvement",
              changeBullets: [
                  {
                      bulletContent: "Quick Task Creation",
                      subBullets: [
                          "Introduced Quick Add feature for faster task creation",
                          "Enhanced task creation workflow"
                      ]
                  }
              ]
          }
      ]
  },

  // Version 1.1.6
  // ----------------------------------------------------------------------------
  {
      version: "1.1.6",
      date: "2024-11-13",
      description: "Mobile experience improvements",
      changes: [
          {
              changeTitle: "Mobile Support",
              changeType: "improvement",
              changeBullets: [
                  {
                      bulletContent: "Mobile Optimization",
                      subBullets: [
                          "Enhanced mobile responsiveness across core features",
                          "Improved mobile navigation and accessibility"
                      ]
                  }
              ]
          }
      ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.1.5
  // ----------------------------------------------------------------------------
  {
      version: "1.1.5",
      date: "2024-11-10",
      description: "Enhanced monitoring capabilities and activity tracking",
      changes: [
          {
              changeTitle: "Platform Improvements",
              changeType: "improvement",
              changeBullets: [
                  {
                      bulletContent: "Monitoring Enhancements",
                      subBullets: [
                          "Improved monitor management for organizations",
                          "Enhanced activity tracking visualization"
                      ]
                  }
              ]
          }
      ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.1.4
  // ----------------------------------------------------------------------------
  {
      version: "1.1.4",
      date: "2024-11-08",
      description: "Enhanced task organization capabilities",
      changes: [
          {
              changeTitle: "Task Management",
              changeType: "improvement",
              changeBullets: [
                  {
                      bulletContent: "Multi-Task Management",
                      subBullets: [
                          "Introduced ability to manage multiple tasks simultaneously",
                          "Enhanced task organization features"
                      ]
                  }
              ]
          }
      ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.1.3
  // ----------------------------------------------------------------------------
  {
      version: "1.1.3",
      date: "2024-11-02",
      description: "Improved task organization and sorting capabilities",
      changes: [
          {
              changeTitle: "Task Organization",
              changeType: "improvement",
              changeBullets: [
                  {
                      bulletContent: "Task Management",
                      subBullets: [
                          "Enhanced task organization capabilities",
                          "Improved task sorting and categorization"
                      ]
                  }
              ]
          }
      ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.1.2
  // ----------------------------------------------------------------------------
  {
      version: "1.1.2",
      date: "2024-10-27",
      description: "Enhanced task management system",
      changes: [
          {
              changeTitle: "Platform Improvements",
              changeType: "improvement",
              changeBullets: [
                  {
                      bulletContent: "Task Management",
                      subBullets: [
                          "Improved task details management",
                          "Enhanced organization features"
                      ]
                  }
              ]
          }
      ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.1.1
  // ----------------------------------------------------------------------------
  {
      version: "1.1.1",
      date: "2024-10-24",
      description: "Enhanced file management and notification system",
      changes: [
          {
              changeTitle: "Platform Features",
              changeType: "improvement",
              changeBullets: [
                  {
                      bulletContent: "File Management",
                      subBullets: [
                          "Enhanced file upload capabilities",
                          "Added support for larger file sizes",
                          "Improved drag and drop functionality"
                      ]
                  },
                  {
                      bulletContent: "Notifications",
                      subBullets: [
                          "Improved notification system integration"
                      ]
                  }
              ]
          }
      ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.1.0
  // ----------------------------------------------------------------------------
  {
      version: "1.1.0",
      date: "2024-10-20",
      description: "System stability improvements",
      changes: [
          {
              changeTitle: "Platform Stability",
              changeType: "improvement",
              changeBullets: [
                  {
                      bulletContent: "System Improvements",
                      subBullets: [
                          "Enhanced system reliability",
                          "Improved error handling"
                      ]
                  }
              ]
          }
      ]
  },

  // ----------------------------------------------------------------------------
  // Version 1.0.0
  // ----------------------------------------------------------------------------
  {
      version: "1.0.0",
      date: "2024-09-29",
      description: "Initial platform release",
      changes: [
          {
              changeTitle: "Platform Launch",
              changeType: "feature",
              changeBullets: [
                  {
                      bulletContent: "Core Features",
                      subBullets: [
                          "Launched monitoring system",
                          "Implemented user authentication",
                          "Introduced task management",
                          "Added collaboration features"
                      ]
                  }
              ]
          }
      ]
  }
];